import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'
import { productSubItemSchema } from './product-sub-item'

/**
 * 產品子類目 - 單筆資料 Schema
 */
export const productSubDataSchema = z.object({
  /** 用途說明(英) */
  descriptionEn: z.string(),
  /** 用途說明(中) */
  descriptionZh: z.string(),
  /** 是否上架 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 子網頁分類 */
  items: z.array(productSubItemSchema),
  /** 異動日期 */
  modifyDate: z.string(),
  /** 異動者 */
  modifyUser: z.string(),
  /** 子類目名稱(英) */
  nameEn: z.string(),
  /** 子類目名稱(中) */
  nameZh: z.string(),
  /** 主類目 ID */
  pmID: z.number().optional(),
  /** 子類目 ID */
  psID: z.number().optional(),
  /** 排序 */
  sort: z.union([z.number(), z.literal('')])
})

export interface ProductSubData extends z.infer<typeof productSubDataSchema> {}

export class ProductSubData {
  constructor() {
    return {
      descriptionEn: '',
      descriptionZh: '',
      isEnable: TrueFalse.TRUE,
      modifyUser: '',
      modifyDate: '',
      items: [],
      nameEn: '',
      nameZh: '',
      pmID: undefined,
      psID: undefined,
      sort: 0
    }
  }
}
